export default __webpack_public_path__ + "static/media/syndicate-icon.244a6dae.svg";